
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { useState } from "react";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import About from "./pages/About";
import Careers from "./pages/Careers";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import TermsOfService from "./pages/TermsOfService";
import Blog from "./pages/Blog";
import BlogPostDetail from "./pages/BlogPostDetail";
import ContactUs from "./pages/ContactUs";
import Services from "./pages/Services";
import ApplicationSecurity from "./pages/services/ApplicationSecurity";
import DevSecOps from "./pages/services/DevSecOps";
import OffensiveSecurity from "./pages/services/OffensiveSecurity";
import SecurityAdvisoryServices from "./pages/services/SecurityAdvisoryServices";
import CloudSecurity from "./pages/services/CloudSecurity";
import PreferenceCenter from "./pages/PreferenceCenter";
import UnsubscribePage from "./pages/UnsubscribePage";
import PreferenceManagementPage from "./pages/PreferenceManagementPage";
import Admin from "./pages/Admin";

const TokenRedirect = () => {
  const { token } = useParams<{ token: string }>();
  return <Navigate to={`/subscription-management/${token}`} replace />;
};

const App = () => {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/about" element={<About />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPostDetail />} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/contact-us" element={<Navigate to="/contactus" replace />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/application-security" element={<ApplicationSecurity />} />
            <Route path="/services/devsecops" element={<DevSecOps />} />
            <Route path="/services/offensive-security" element={<OffensiveSecurity />} />
            <Route path="/services/security-advisory" element={<SecurityAdvisoryServices />} />
            <Route path="/services/cloud-security" element={<CloudSecurity />} />
            <Route path="/subscription-management" element={<PreferenceManagementPage />} />
            <Route path="/subscription-management/:token" element={<PreferenceManagementPage />} />
            <Route path="/preferences" element={<Navigate to="/subscription-management" replace />} />
            <Route path="/unsubscribe" element={<Navigate to="/subscription-management" replace />} />
            <Route path="/unsubscribe/:token" element={<TokenRedirect />} />
            <Route path="/newsletter/confirm" element={<Navigate to="/subscription-management" replace />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/submissions" element={<Admin />} />
            <Route path="/admin/campaigns" element={<Admin />} />
            <Route path="/admin/cti" element={<Admin />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
